// extracted by mini-css-extract-plugin
export default {"wrapper":"UY-z","message":"VY-z","image":"WY-z"};